<template>
  <b-navbar toggleable="md" type="dark" class="main-header">
    <b-navbar-brand :to="{ name: 'main' }" class="main-header__title">
      <div class="main-header__title-text">Акты ЛПО</div>
    </b-navbar-brand>

    <b-navbar-nav class="main-nav-block ml-5">
      <b-nav-item :to="{ name: 'create-lpo' }" class="mr-2 pr-2 pl-2">
        <b-icon icon="clipboard-plus" class="mr-1"></b-icon>
        Новое обследование
      </b-nav-item>
      <b-nav-item :to="{ name: 'journal-lpo' }" class="mr-2 pr-2">
        <b-icon icon="journal-bookmark-fill" class="mr-1"></b-icon>
        Журнал ЛПО
      </b-nav-item>
      <b-nav-item :to="{ name: 'tax-info' }" class="mr-2 pr-2">
        <b-icon icon="journal-bookmark" class="mr-1"></b-icon>
        Таксационные описания
      </b-nav-item>
    </b-navbar-nav>

    <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown>
            <template #button-content>
                <b-icon icon="book" class="mr-1"></b-icon>
                Помощь
            </template>
            <b-dropdown-item @click="openQuestions" class="mr-2 pr-2">
              <b-icon icon="question-square" class="mr-1"></b-icon>
              Часто задаваемые вопросы и ответы на них
            </b-dropdown-item>
            <b-dropdown-item @click="openTutorial" class="mr-2 pr-2">
                <b-icon icon="journal-bookmark" class="mr-1"></b-icon>
                Руководство пользователя
            </b-dropdown-item>
            <b-dropdown-item @click="openVideoTutorial" class="mr-2 pr-2">
                <b-icon icon="camera-video" class="mr-1"></b-icon>
                Видеоинструкция
            </b-dropdown-item>
            <b-dropdown-item class="mb-1" @click="openTechSupport">
              <b-icon icon="headset" class="mr-2"></b-icon>
              Техподдержка
            </b-dropdown-item>
        </b-nav-item-dropdown>
      <b-nav-item-dropdown right>
        <template #button-content>
          <b-icon icon="person-fill" class="mr-1"></b-icon>
          {{ userName }}
        </template>
        <!-- <template v-if='broadcastAllowed'>
	  			<b-dropdown-item @click='broadcast'>
	  				<b-icon icon='broadcast-pin' class='mr-2'></b-icon>
	  				Сделать рассылку
	  			</b-dropdown-item>
	  			<b-dropdown-divider></b-dropdown-divider>
	  		</template> -->
        <template v-if="user.filial_id == '1'">

          <b-dropdown-item :to="{ name: 'importxml' }">
            <b-icon icon="files" class="mr-2"></b-icon>
            Импорт XML
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
        </template>
        <template v-if="registerAllowed">
          <b-dropdown-item :to="{ name: 'register' }">
            <b-icon icon="person-plus-fill" class="mr-2"></b-icon>
            Регистрация пользователей
          </b-dropdown-item>
          <b-dropdown-item :to="{ name: 'removeuser' }">
            <b-icon icon="person-dash-fill" class="mr-2"></b-icon>
            Удаление пользователей
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
        </template>
        <b-dropdown-item class="mb-1" @click="openChangePass">
          <b-iconstack class="mr-2">
            <b-icon stacked icon="arrow-clockwise" scale="1.3"></b-icon>
            <b-icon stacked icon="lock-fill" scale="0.5"></b-icon>
          </b-iconstack>
          Изменить пароль
        </b-dropdown-item>
        <b-dropdown-item @click="logout">
          <b-icon icon="box-arrow-left" class="mr-2"></b-icon>
          Выйти
        </b-dropdown-item>
      </b-nav-item-dropdown>

      <!--
        <b-nav-item-dropdown right no-caret class="ml-3">
        <template #button-content>
          <b-iconstack>
            <b-icon stacked icon="circle" scale="1.5"></b-icon>
            <b-icon stacked icon="three-dots"></b-icon>
          </b-iconstack>
        </template>
        <b-dropdown-item class="mb-1" @click="openTutorial">
          <b-icon icon="book" class="mr-2"></b-icon>
          Руководство пользователя
        </b-dropdown-item>
        <b-dropdown-item class="mb-1" @click="openTechSupport">
          <b-icon icon="headset" class="mr-2"></b-icon>
          Техподдержка
        </b-dropdown-item>
      </b-nav-item-dropdown>
    -->
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

import fetchData from "@/lib/fetchData";
const ROOT_API = process.env.VUE_APP_ROOT_API;
const BROADCAST = ROOT_API + "tech_support_broadcast.php";

export default {
  name: "MainHeader",

  data: () => ({
    isChangePassOpen: false,
  }),

  computed: {
    userName() {
      return this.user ? this.user.name : "[[ нет данных ]]";
    },

    registerAllowed() {
      const userId = this.user ? this.user.id : null;

      return (
        userId === "1" || 
        userId === "9" || 
        userId === "35" || 
        userId === "149" || 
        userId === "180" ||
        userId === "689"
      );
    },

    broadcastAllowed() {
      const userId = this.user ? this.user.id : null;
      return userId === "1";
    },

    ...mapState("user", {
      user: (state) => state.user,
    }),
  },
  methods: {
    broadcast() {
      return fetchData(BROADCAST).then((res) => {
        console.log("broadcast done:");
        console.log(res);
      });
    },

    openTutorial() {
      window.open("./tutorial.pdf");


      // return;

      // let routeData = this.$router.resolve({ path: '@/assets/files/forest.jpg' });
      // console.log(routeData);

      // window.open(routeData.href, '_blank');
    },
    openVideoTutorial() {
      this.$router.push('/videotutorial');
    },
    openQuestions() {
        window.open("./questions.pdf");
    },
    openTechSupport() {
      this.$emit("open-tech-support");
    },

    openChangePass() {
      this.$emit("open-change-pass");
    },

    toRegister() {
      const route_obj = {
        name: "register",
      };
      this.$router.push(route_obj);
    },

    logout() {
      this.s_logout().finally(() => {
        this.s_setUserInfo(null);
        this.$router.push({ name: "login" });
      });
    },

    ...mapMutations("user", {
      s_setUserInfo: "setUserInfo",
    }),

    ...mapActions("auth", {
      s_logout: "logout",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/constants.scss";

.main-header {
  font-size: 1rem;

  background-color: $color-green;
  // background-color: #3D916F;
  // background-image: linear-gradient(180deg,hsla(0,0%,100%,0.3),hsla(0,0%,100%,0) 50%,rgba(0,0,0,0.12) 51%,rgba(0,0,0,0.04));
}

.main-header::v-deep .main-nav-block .nav-item:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.4);
}
.main-header::v-deep .main-nav-block .nav-item {
  border-right: 1px solid rgba(255, 255, 255, 0.4);
}

.main-header::v-deep .nav-item > a {
  color: rgba(255, 255, 255, 0.8);
}
.main-header::v-deep .nav-item > a:hover {
  color: rgba(255, 255, 255, 0.9);
}
.main-header::v-deep .nav-item > a:active {
  color: rgba(255, 255, 255, 1);
}

.main-header__title {
  font-weight: bold;
  /*display: flex;*/
  /*align-items: center;*/
}

/*.main-header__title-img-container {
		background-color: white;
		padding: 2px;
		border-radius: 50%;
	}*/
</style>
